module.exports = __webpack_public_path__ + "static/media/ios-microphone.39d8c810.svg";